import type { SessionState } from "./session";

export interface GuestNotice {
  title: string;
  body: string;
}

/**
 * 로그인하지 않은 화면에 무엇이라고 쓸지 정합니다.
 *
 * 서버에 닿지 못한 것과 로그인하지 않은 것은 다릅니다. 구분하지 않으면
 * 서버가 죽었을 때도 "로그인하면 …" 이라고 말하게 되고, 사용자는 되지도 않을
 * 로그인을 시도합니다. 세션 계층이 이미 이유를 알고 있으니 해석도 여기서
 * 한 번만 합니다 — Web 과 Native 가 같은 상황에서 다른 말을 하면 안 됩니다.
 *
 * `loading` 은 아직 모르는 상태입니다. 장애라고 단정하지 않고 기본 문구를 씁니다.
 */
export function guestNotice(state: SessionState, whenSignedOut: GuestNotice): GuestNotice {
  if (state.status === "guest" && state.reason === "unverifiable") {
    return {
      title: "서버에 연결하지 못했어요",
      body: "로그인 문제가 아닙니다. 잠시 후 다시 시도해 주세요.",
    };
  }
  return whenSignedOut;
}
